<!-- 设置弹窗 -->
<template>
  <el-dialog
    title="组别设置"
    :visible.sync="dialogVisible"
    width="270px"
    class="patRecord-dialog"
    @close="handleClose"
    >
    <el-form :model="ruleForm">
      <el-form-item label="用户组">
        <el-select v-model="ruleForm.team" placeholder="请选择">
          <el-option label="诊断组" value="诊断组"></el-option>
          <el-option label="技术组" value="技术组"></el-option>
          <el-option label="护理组" value="护理组"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="save">保 存</el-button>
        <el-button size="medium" @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {changeUserTeam} from '../../api/api.js'
export default {
  name: '',
  mixins: [],
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      dialogVisible: false,
      ruleForm: {
        team: ''
      }
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
      if (val) {
        this.ruleForm.team = this.userInfo.user.team
      }
    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {
    save () {
      if (!this.ruleForm.team) {
        this.$message.error('请选择一个组')
      }
      changeUserTeam(this.ruleForm).then(res => {
        this.$message.success('保存成功')
        let obj = JSON.parse(JSON.stringify(this.userInfo))
        obj.user.team = this.ruleForm.team
        this.$emit('update:userInfo', obj)
        this.handleClose()
      })
    },
    handleClose () {
      this.ruleForm.team = ''
      this.$emit('update:visible', false)
    }
  },
  beforeDestroy () {},
  destroyed () {}
}
</script>
<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// packages/chat/src/settingDialog.vue